import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PageSEO from "@/components/PageSEO";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageSEO
        title="Terms of Service | Marquetta Bryant"
        description="Terms of service for marquettabryant.com covering real estate advisory, mortgage consulting, coaching, speaking, and educational services."
        canonical="https://marquettabryant.com/terms"
      />
      <Header />
      <main className="pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <h1 className="text-3xl md:text-4xl font-bold mb-8">Terms of Service</h1>
            <p className="text-muted-foreground mb-6">Last updated: {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground mb-4">By accessing and using this website, you agree to be bound by these Terms of Service. If you do not agree, please do not use the site.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">2. Services</h2>
            <p className="text-muted-foreground mb-4">Marquetta Bryant provides real estate advisory, mortgage consulting, coaching, speaking, and educational services. All services are subject to availability and may be modified at any time.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">3. Intellectual Property</h2>
            <p className="text-muted-foreground mb-4">All content on this website — including text, images, logos, and branding — is the property of Marquetta Bryant and may not be reproduced without written permission.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">4. Payments & Refunds</h2>
            <p className="text-muted-foreground mb-4">Payments for events, coaching, and services are processed through secure third-party providers. Refund policies are specific to each service and will be communicated at the time of purchase.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">5. Disclaimer</h2>
            <p className="text-muted-foreground mb-4">The information provided on this website is for general informational purposes only. It does not constitute financial, legal, or professional advice. Results may vary.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">6. Limitation of Liability</h2>
            <p className="text-muted-foreground mb-4">Marquetta Bryant shall not be liable for any direct, indirect, or consequential damages arising from the use of this website or services.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">7. Mortgage Disclosure</h2>
            <p className="text-muted-foreground mb-4">Marquetta Bryant is a Loan Officer with One Real Mortgage (NMLS #2512081). Fresh Vision Realty and One Real Mortgage are separate entities. All mortgage-related services are subject to applicable state and federal regulations.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">8. Changes</h2>
            <p className="text-muted-foreground mb-4">We reserve the right to update these terms at any time. Continued use of the site constitutes acceptance of the revised terms.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
